<template>
    <b-row>
        <b-col>
            <select-filter
              variant="info"
              :icon="sample_type.icon"
              placeholder="All Sample Types"
              :collection="sample_type.filters"
              value-key="id"
              text-key="name"
              filter-field="test_package.sample_type_id"
              filter-operator="eq"
              @onSelect="setFilter('sample_type', $event)"
            />
        </b-col>
        <b-col class="p-0">
            <select-filter
              variant="info"
              :icon="test_package.icon"
              placeholder="All Test Packages"
              :collection="test_package.filters"
              value-key="id"
              text-key="name"
              filter-field="test_package_id"
              filter-operator="eq"
              @onSelect="setFilter('test_package', $event)"
            />
        </b-col>
    </b-row>
</template>
<script>
import { getCollection } from "@/shared/fetch-utils";
import SampleTypeModel from "@/models/lab/SampleTypeModel";
import TestPackageModel from "@/models/lab/TestPackageModel";
import SelectFilter from "@/components/shared/SelectFilter";

export default {
    name: "QualityControlTableFilters",
    components: {
        SelectFilter,
    },
    data() {
        return {
            sample_type_collection: null,
            test_package_collection: null,
        };
    },
    computed: {
        sample_type() {
            return {
                icon: `fa-${SampleTypeModel.iconStatic()}`,
                filters: this.sample_types || this.sample_type_collection,
            };
        },
        test_package() {
          return {
                icon: `fa-${TestPackageModel.iconStatic()}`,
                filters: this.test_packages || this.test_package_collection,
            };
        },
    },
    methods: {
        async init() {
            const payload = {
                sort: [
                  {
                    logic: "sortAddAsc",
                    field: "name",
                  },
                ],
                limit: "all",
                message: this.$bvToast,
            };

            !this.sample_types &&
                (this.sample_type_collection = await getCollection({
                    ...payload,
                    collection_type: "sample_type",
                }));
            !this.test_packages &&
              (this.test_package_collection = await getCollection({
                ...payload,
                collection_type: "test_package",
              }));
            
            this.ready();
        },
        setFilter(type, event) {
            this.$emit('onSelect', type, event);
        },
        ready() {
            if (this.test_package_collection && this.sample_type_collection) {
                this.$emit('ready');
            }
        }
    },
    created() {
        this.init();
    }
};
</script>